module.exports = __webpack_public_path__ + "static/media/yt-icon.d3e348b2.png";